// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Please enter a valid email address`
};

const de_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte gib eine gültige E-Mail-Adresse ein`
};

const es_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor ingresa una dirección de correo electrónico válida`
};

const fr_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Veuillez entrer une adresse email valide`
};

const fi_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Anna kelvollinen sähköpostiosoite`
};

const ja_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `有効なメールアドレスを入力してください`
};

const nl_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Voer een geldig e-mailadres in`
};

const pt_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, insira um endereço de email válido`
};

const ro_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Te rugăm să introduci o adresă de email validă`
};

const th_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `กรุณากรอกที่อยู่อีเมลที่ถูกต้อง`
};

const ur_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `براہ کرم درست ای میل ایڈریس درج کریں`
};

const zh_hant1_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `請輸入有效的電子郵件地址`
};

const da_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Indtast venligst en gyldig e-mailadresse`
};

const it_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Inserisci un indirizzo email valido`
};

const vn_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Vui lòng nhập địa chỉ email hợp lệ`
};

const ko_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `유효한 이메일 주소를 입력해주세요`
};

const tr_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Lütfen geçerli bir e-posta adresi girin`
};

const lv_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Lūdzu, ievadiet derīgu e-pasta adresi`
};

const ar_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `يرجى إدخال عنوان بريد إلكتروني صحيح`
};

const bs_widget_login_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Molimo unesite važeću email adresu`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_invalid_email = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_invalid_email(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_invalid_email", locale)
	if (locale === "en") return en_widget_login_invalid_email(inputs)
	if (locale === "de") return de_widget_login_invalid_email(inputs)
	if (locale === "es") return es_widget_login_invalid_email(inputs)
	if (locale === "fr") return fr_widget_login_invalid_email(inputs)
	if (locale === "fi") return fi_widget_login_invalid_email(inputs)
	if (locale === "ja") return ja_widget_login_invalid_email(inputs)
	if (locale === "nl") return nl_widget_login_invalid_email(inputs)
	if (locale === "pt") return pt_widget_login_invalid_email(inputs)
	if (locale === "ro") return ro_widget_login_invalid_email(inputs)
	if (locale === "th") return th_widget_login_invalid_email(inputs)
	if (locale === "ur") return ur_widget_login_invalid_email(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_invalid_email(inputs)
	if (locale === "da") return da_widget_login_invalid_email(inputs)
	if (locale === "it") return it_widget_login_invalid_email(inputs)
	if (locale === "vn") return vn_widget_login_invalid_email(inputs)
	if (locale === "ko") return ko_widget_login_invalid_email(inputs)
	if (locale === "tr") return tr_widget_login_invalid_email(inputs)
	if (locale === "lv") return lv_widget_login_invalid_email(inputs)
	if (locale === "ar") return ar_widget_login_invalid_email(inputs)
	if (locale === "bs") return bs_widget_login_invalid_email(inputs)
	return "widget_login_invalid_email"
};